import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  goToTerms(lang: string) {
    this.router.navigate(['/terms/' + lang]);
  }

  goToPolicies(lang: string) {
    this.router.navigate(['/policies/' + lang]);
  }
}